var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"toast-fade"}},[(_vm.showToast)?_c('span',{staticClass:"totem-toast",style:(_vm.cssVars),domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }